import { serializable, DynamicFormControlLayout, DynamicInputModelConfig, DynamicInputModel } from '@ng-dynamic-forms/core';
import { Model_WorkflowComponent, Model_VariableEnvironnement, CODE_WORKFLOW_COMPONENT, FONCTION_WORKFLOW_COMPONENT_OPTIONS } from 'src/app/app.models';
import { COMPONENT_MODE, COMPONENT_UI } from '../workflow-components.models';

export class Model_WorkflowRichAutoCompleteComponent extends Model_WorkflowComponent {
    workflowComponents: Model_WorkflowComponent[];
    variablesEnvironnement: Model_VariableEnvironnement[];
	typeInput?: CODE_WORKFLOW_COMPONENT;
}
  
export interface RichAutocompleteModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE;
    workflowComponents: Model_WorkflowComponent[];
    variablesEnvironnement: Model_VariableEnvironnement[];
    fonctionsIds: { ID: string, TEXT: string }[];
	typeInput?: CODE_WORKFLOW_COMPONENT;
}
  
export class RichAutocompleteModel extends DynamicInputModel {
	@serializable() readonly type: string = 'rich_autocomplete';
	componentMode: COMPONENT_MODE;
	componentUI: COMPONENT_UI;
    workflowComponents: Model_WorkflowComponent[];
    variablesEnvironnement: Model_VariableEnvironnement[];
    fonctionsIds: { ID: string, TEXT: string }[] = [];
	typeInput = CODE_WORKFLOW_COMPONENT.TEXTBOX;
	
	constructor(config: RichAutocompleteModelConfig, layout?: DynamicFormControlLayout) {
        super(config, layout);
		this.componentMode = config.componentMode;
        this.workflowComponents = config.workflowComponents;
        this.variablesEnvironnement = config.variablesEnvironnement;
		if (!!config.fonctionsIds) {
			this.fonctionsIds = config.fonctionsIds;
		}
		if (!!config.typeInput) {
			this.typeInput = config.typeInput;
		}
		this.componentUI = COMPONENT_UI.IONIC;
	}

	public static initModel(_component: Model_WorkflowRichAutoCompleteComponent) {
		const formModel = new RichAutocompleteModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
            value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
			relations: _component.RELATIONS,
			additional: _component,
			workflowComponents: _component.workflowComponents,
			variablesEnvironnement: _component.variablesEnvironnement,
			fonctionsIds: FONCTION_WORKFLOW_COMPONENT_OPTIONS.map(f => ({ ID: f.mVALUE_MEMBER, TEXT: f.mDISPLAY_MEMBER })),
			typeInput: !!_component.typeInput ? _component.typeInput : CODE_WORKFLOW_COMPONENT.TEXTBOX
		});
		return formModel;
	}
}
  